import { CardWithPointer } from 'src/store/view/types';
import { getCurrentTransmission } from '../utils';
import { getRawLabel } from '../../utils/labels';

export const getBroadcastAttributes = (
  card: CardWithPointer
): {
  'data-broadcast-start-date': string;
  'data-broadcast-end-date': string;
} => {
  const currentTransmission = getCurrentTransmission(card.transmissions);

  if (currentTransmission) {
    return {
      'data-broadcast-start-date': currentTransmission.startTime,
      'data-broadcast-end-date': currentTransmission.endTime,
    };
  }

  return {
    'data-broadcast-start-date': getRawLabel(card, 'broadcastStartDate') || '',
    'data-broadcast-end-date': getRawLabel(card, 'broadcastEndDate') || '',
  };
};
